import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";
import CollapseHeader from "../../../../core/common/collapse-header/collapse-header";
import CopyRightInfo from "../../../../core/common/copyRightInfo";
import Table from "../../../../core/common/dataTable/index";
import ChatSettingsMenu from "./common/setting-menu";
import DropDown from '../../../../core/common/commonDropDown';
import PreLoader from "../../../../core/common/preLoader";
import useFetch from "../../../../hooks/useFetch";
import { API, MONTHS_OPTS } from "../../../../common/Constants";
import { getAPIHeaders } from "../../../../common/Utils";
import { ChatTokenTopupRecord, TokenAllocationSummary } from "../../../../types/dataModel";
import CommonTabMenu from "../commonTabMenu";


const TokenTopupHistory = () => {
  const routes = all_routes;
  const { isLoading, callFetch } = useFetch();
  const [topupHistory, setTopupHistory] = React.useState<ChatTokenTopupRecord[]>([]);
  const [selectedMonth, setSelectedMonth] = React.useState<any | undefined>(String(new Date().getMonth() + 1).padStart(2, '0'));
  const [selectedYear, setSelectedYear] = React.useState<any | undefined>(String(new Date().getFullYear()));
  const [tokenLimits, setTokenLimits] = React.useState<TokenAllocationSummary>({});

  React.useEffect(() => {
    fetchTokenTopupHistory();
    fetchFeatureTokenLimits();
  }, []);


  React.useEffect(() => {
    if (selectedMonth && selectedYear) {
      fetchTokenTopupHistory();
    }
  }, [selectedMonth, selectedYear]);

  const fetchTokenTopupHistory= () => {
      callFetch(API.SETTINGS_AI_TOKEN_TOPUP_HISTORY.replace(':featureId', 'AI_SG_001'), 
      'GET', 
      getAPIHeaders(), 
      { month: selectedMonth, year: selectedYear }, 
      null
      ).then((res) => {
        setTopupHistory(res || []);
      }).catch((err) => {});
  }

  const fetchFeatureTokenLimits = () => {
    callFetch(API.SETTINGS_AI_FEATURE_ALLOCATION.replace(':featureId', 'AI_SG_001'),
      'GET',
      getAPIHeaders(),
      null,
      null
    ).then((res) => {
      setTokenLimits(res)
    }).catch((err) => { });
  }

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      sorter: (a: any, b: any) => a.id - b.id,
    },
    {
      title: "Reason",
      dataIndex: "reason",
      sorter: (a: any, b: any) => a.reason?.localeCompare(b.reason),
      defaultSortOrder: "ascend",
    },
    {
      title: "Month",
      dataIndex: "month",
      sorter: (a: any, b: any) => a.month?.localeCompare(b.month),
    },
    {
      title: "Tokens Added",
      dataIndex: "tokensAdded",
      sorter: (a: any, b: any) => a.tokensAdded - b.tokensAdded,
    },
    {
      title: "Tokens Cost (INR)",
      dataIndex: "tokensAddedCostInr",
      sorter: (a: any, b: any) => a.tokensAddedCostInr - b.tokensAddedCostInr,
    },
  ]

  const renderFilters = () => {
    return (
      <div className="d-flex align-items-center gap-3 flex-wrap">
        <div className="d-flex align-items-center">
          <DropDown
            value={selectedMonth}
            options={MONTHS_OPTS}
            onChange={(val) => {
              setSelectedMonth(val);
            }} 
            defaultValue={String(new Date().getMonth() + 1).padStart(2, '0')}
             
            />
            <DropDown
            value={selectedYear}
            options={Array.from({ length: new Date().getFullYear() - 2025 + 1 }, (_, i) => ({
              value: (2025 + i).toString(),
              label: (2025 + i).toString(),
            })).reverse()}
            onChange={(val) => {
              setSelectedYear(val);
            } } 
            defaultValue={String(new Date().getFullYear())}         
          />
        </div>
      </div>
    )
  }

  const renderTokenCalculation = () => {
      return (
        <div className="border rounded p-3">
          {(() => {  
            return (
              <>
                <h5 className="mb-3">Token Allocation</h5>
                <div className="d-flex flex-column">
                  <h6 className="mb-2">Total Tokens: <span className="text-primary">{tokenLimits?.effectiveFeatureMaxLimit || 0}</span> , Topups: <span className="text-secondary">{tokenLimits?.totalTopUps || 0} </span></h6>
                </div>
              </>
            );
          })()}
        </div>)
  }

  return (
    <div>
      <>
        {/* Page Wrapper */}
        <PreLoader showLoader={isLoading} />
        <div className="page-wrapper">
          <div className="content">
            {/* Breadcrumb */}
            <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
              <div className="my-auto mb-2">
                <h2 className="mb-1">Syllabus Generator Settings</h2>
                <nav>
                  <ol className="breadcrumb mb-0">
                    <li className="breadcrumb-item">
                      <Link to={routes.adminDashboard}>
                        <i className="ti ti-smart-home" />
                      </Link>
                    </li>
                    <li className="breadcrumb-item">Administration</li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Settings
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
            {/* /Breadcrumb */}
            <CommonTabMenu activeTab="SyllabusGenerator"/>
            <div className="row">
              <div className="col-xl-3 theiaStickySidebar">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex flex-column list-group settings-list">
                     <ChatSettingsMenu activeTab="TokenTopupHistory" />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-9">
                <div className="card">
                  <div className="card-body">
                    <div className="border-bottom pb-3 justify-content-between d-flex align-items-center">
                      <h4>Token Topup History</h4>
                      {renderFilters()}
                    </div>
                    <div className="row align-items-center mt-2">
                      <div className="col-12">
                        {renderTokenCalculation()}
                      </div>
                    </div>
                    <Table dataSource={topupHistory} columns={columns} Selection={false} refresh={fetchTokenTopupHistory} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer d-sm-flex align-items-center justify-content-center border-top bg-white p-3">
            <CopyRightInfo/>
          </div>
        </div>
        {/* /Page Wrapper */}
      </>

    </div>
  );
};

export default TokenTopupHistory;